const vi = {
    messages: {
        pricing: 'Chi phí',
        blog: 'Blog',
        blogdescription: 'Thông tin mới nhất về RPA CLOUD',
        profile: 'Trang cá nhân',
        signout: 'Đăng xuất',
        signin: 'Đăng nhập',
        tryforfree: 'Đăng ký miễn phí',
        privacypolicy: 'Quyền riêng tư',
        contact: 'Liên hệ',
        opensettings: 'Cài đặt',
        signintoocto: 'Đăng nhập {name}',
        welcomeback: 'Chào bạn!',
        pleasesignin: 'Vui lòng đăng nhập.',
        email: 'Email',
        password: 'Mật khẩu',
        forgotyourpassword: 'Bạn đã quên mật khẩu?',
        forgotyourpassworddescription: 'Nhập email bạn đã đăng ký.Nếu tài khoản đã tồn tại, chúng tôi sẽ gửi link cài đặt mật khẩu vào email của bạn.',
        emailaddress: 'Địa chỉ email',
        sendpasswordreset: 'Gửi lại mật khẩu',
        sendpasswordresetmsg: 'Chúng tôi đã gửi email đến địa chỉ {email}, với link cài đặt mật khẩu.Link chỉ có hiệu lực trong 10 phút',
        resetyourpassword: 'Cài đặt lại mật khẩu',
        resetyourpassworddescription: 'Nhập mật khẩu mới.',
        resetpassword: 'Cài đặt lại mật khẩu',
        newpassword: 'Mật khẩu mới',
        confirmpassword: 'Xác nhận mật khẩu',
        firstname: 'Tên',
        lastname: 'Họ',
        agreetryforfree: 'Đồng ý dùng thử',
        free: 'Free',
        standard: 'Standard',
        premium: 'Premium',
        enterprise: 'Enterprise',
        cooperation: 'Cooperation',
        agreeconfirm: 'Bằng việc nhấn vào nút bên dưới, bạn đồng ý với các điều khoản của chúng tôi ',
        tel: 'Điện thoại',
        useastrongpassword: 'Sử dụng mật khẩu mạnh hơn',
        whichplanwouldyouliketouse: 'Bạn muốn sử dụng gói nào?',
        weak: 'Yếu',
        okay: 'Tạm được',
        good: 'Tốt',
        strong: 'Mạnh',
        stronger: 'Mạnh hơn',
        tooshort: 'Quá ngắn',
        talktous: 'Liên hệ với chúng tôi',
        talktousdescription: 'Vui lòng điền thông tin dưới đây và chúng tôi sẽ liên lạc với bạn ngay',
        talktousdescription2: 'Liên lạc trực tiếp với chúng tôi qua',
        orphone: 'hoặc điện thoại',
        whatcanwehelpwith: 'Chúng tôi có thể giúp gì cho bạn?',
        send: 'Gửi',
        phonenumber: 'Số điện thoại',
        rpacloudslogan: 'RPA CLOUD - Nhà cung cấp trợ lý ảo thông minh',
        rpaclouddescription: 'RPA CLOUD phần mềm robot với giao diện thân thiện, dễ sử dụng, giúp bạn tự động hóa các công việc với chi phí vô cùng hợp lý. Robot sẽ làm việc thay bạn 24/7 và bạn không cần phải biết kiến thức về lập trình mà vẫn có thể tạo ra robot một cách đơn giản và nhanh chóng nhất.',
        contactsales: 'Liện lạc ngay',
        feature: 'Tính năng',
        featuredescription: 'Hãy cùng trải nghiệm những tính năng độc đáo mà RPA CLOUD mang lại cho bạn.',
        bynow: 'Mua ngay',
        months: 'Tháng',
        standardprice: '299K',
        standarddescription: [
            'Bao gồm 1 tài khoản',
            'Bao gồm 5 robot',
            'Bao gồm 5 lịch chạy tự động',
            'Dung lượng 1 GB ',
            'Hỗ trợ trong 48 giờ qua email',
        ],
        premiumprice: '599K',
        premiumdescription: [
            'Bao gồm 1 tài khoản',
            'Bao gồm 10 robot',
            'Bao gồm 10 lịch chạy tự động',
            'Bao gồm 10 kết nối',
            'Dung lượng 2 GB ',
            'Hỗ trợ qua email ưu tiên',
        ],
        enterpriseprice: '999K',
        enterprisedescription: [
            'Bao gồm 5 tài khoản',
            'Bao gồm 30 robot',
            'Bao gồm 30 lịch chạy tự động',
            'Bao gồm 30 kết nối',
            'Dung lượng 10 GB ',
            'Hỗ trợ qua email và điện thoại',
        ],
        cooperationprice: '',
        cooperationdescription: [
            'Không giới hạn số tài khoản',
            'Không giới hạn số robot',
            'Không giới hạn số lịch trình nhiệm vụ',
            'Không giới hạn số kết nối',
            'Không giới hạn dung lượng',
            'Máy chủ riêng',
            'Hỗ trợ ưu tiên',
        ],
        tryforstandard: 'Dùng thử gói Standard',
        tryforstandarddescription: 'Bạn đã chọn gói Standard',
        msg_schedulehasrunsuccessfully: 'Lịch trình đã chạy thành công.',
        agreetryforstandard: 'Đồng ý sử dụng gói Standard',
        tryforpremium: 'Dùng thử gói Premium',
        tryforpremiumdescription: 'Bạn đã chọn gói Premium',
        agreetryforpremium: 'Đồng ý sử dụng gói Premium',
        tryforenterprise: 'Dùng thử gói Enterprise',
        tryforenterprisedescription: 'Bạn đã chọn gói Enterprise',
        agreetryforenterprise: 'Đồng ý sử dụng gói Enterprise',
        searchblog: 'Tìm Blog',
        pricingdescription: 'Chúng tôi cung cấp các gói Standard, Premium, Enterprise, Cooperation. Chọn gói phù hợp với nhu cầu của bạn.',
        close: 'Đóng',
        almostdone: 'Sắp xong rồi!',
        pleaseverifyyouremailaddress: 'Vui lòng xác thực email của bạn.',
        wehavesentanemailto: 'Chúng tôi đã gửi một email đến:',
        pleasecheckittoverifyyouremail: 'Vui lòng kiểm tra email.',
        needhelp: 'Bạn cần giúp đỡ?',
        contactusat: 'Liên hệ với chúng tôi',
        resendverificationemail: 'Gửi lại email xác nhận',
        msg_resendverificationemailalert: 'Chúng tôi đã gửi email đến địa chỉ {email}. Hãy đăng nhập vào email của bạn để hoàn tất việc xác thực. Link xác thực chỉ có hiệu lực trong 1 giờ.',
        pleaseenteravalidemailaddress: 'Vui lòng nhập địa chỉ email hợp lệ.',
        pleaseenteravalidfirstname: 'Tên chỉ được bao gồm ký tự, khoảng trắng, \'-\', \'.\', hoặc dấu ngoặc.',
        pleaseenteravalidlastname: 'Họ chỉ được bao gồm ký tự, khoảng trắng, \'-\', \'.\', hoặc dấu ngoặc.',
        pleaseenteravalidpassword: 'Mật khẩu phải bao gồm ít nhất 8 ký tự với ít nhất 1 chữ viết hoa, và 1 chữ số.',
        pleaseenteravalidcompanyname: 'Vui lòng nhập tên công ty hợp lệ.',
        pleaseenteravalidtelnumber: 'Vui lòng nhập số điện thoại hợp lệ.',
        msg_error: 'Thông báo lỗi.',
        msg_invalidinformation: 'Email hoặc mật khẩu không chính xác. Vui lòng thử lại hoặc liên lạc với chúng tôi.',
        msg_emailisalreadyexists: 'Email này đã đăng ký thành công.Hãy đăng nhập RPA CLOUD để bắt đầu sử dụng.',
        msg_invalidverifyemailtoken: 'Rất tiếc liên kết xác minh này đã hết hạn. Vui lòng đăng nhập vào RPA CLOUD của bạn và nhấp vào nút "Gửi lại email xác minh" để tạo một liên kết mới.',
        dashboard: 'Tổng quan',
        dashboarddescription: 'Chào mừng bạn đến với RPA CLOUD.',
        cancel: 'Huỷ',
        ok: 'OK',
        signoutconfirm: 'Bạn có chắc muốn đăng xuất?',
        msg_resetpasswordsuccess: 'Đặt lại mật khẩu thành công.',
        msg_invalidemail: 'Email này không tồn tại.',
        passwordisnotmatch: 'Mật khẩu không trùng nhau.',
        msg_thenewpasswordisthesameasthelastpassword: 'Mật khẩu này trùng với mật khẩu lần trước.',
        changelanguage: 'Chọn ngôn ngữ',
        pleaseenteravalidphonenumber: 'Nhập số điện thoại bạn đang sử dụng.',
        pleasefilloutthisfield: 'Điền thông tin dưới đây',
        msg_thanksforcontactingus: 'Cảm ơn đã liên lạc với chúng tôi. Chúng tôi sẽ liên lạc với bạn trong thời gian sớm nhất.',
        registernow: 'Bạn chưa có tài khoản? Đăng ký ngay',
        documentation: 'Tài liệu',
        workspace: 'Robot',
        connection: 'Kết nối',
        storage: 'Lưu trữ',
        storages: 'Lưu trữ',
        userprofile: 'Hồ sơ người dùng',
        userinfor: 'Thông tin người dùng',
        edityouraccountinformation: 'Thay đổi thông tin:',
        save: 'Lưu',
        changeyourpassword: 'Thay đổi mật khẩu',
        currentpassword: 'Mật khẩu hiện tại',
        dashboarddescription_2: 'Robot sẽ làm việc thay bạn,hãy nhanh chóng tạo robot riêng cho chính mình.',
        dashboarddescription_3: 'Tạo robot tự động một cách đơn giản nhất.',
        dashboarddescription_4: 'Theo dõi robot làm việc thông qua hình ảnh robot gửi về.Giảm lượng công việc và tận dụng thời gian hiệu quả hơn.',
        upgrade: 'Nâng cấp',
        currentplan: 'Gói hiện tại',
        schedule: 'Lịch trình',
        tasksdonetoday: 'Nhiệm vụ đã thực hiện hôm nay',
        name: 'Tên',
        timezone: 'Múi giờ',
        description: 'Mô tả',
        result: 'Kết quả',
        triggers: 'Trình kích hoạt',
        role: 'Vai trò',
        package: 'Gói',
        verified: 'Xác thực',
        yes: 'Có',
        no: 'Không',
        success: 'Thành công',
        error: 'Thất bại',
        administrator: 'Quản trị viên',
        user: 'Người dùng',
        expiration: 'Ngày hết hạn',
        action: 'Thao tác',
        upload: 'Tải lên',
        active: 'Hoạt động',
        inactive: 'Không hoạt động',
        status: 'Trạng thái',
        providerid: 'Provider ID',
        size: 'Kích cỡ',
        robotunit: 'robot',
        connectunit: 'kết nối',
        gbunit: 'GB',
        taskunit: 'nhiệm vụ',
        delete: 'Xóa',
        deleted: 'Đã xóa',
        thekeynameisalreadyinuse: 'Tên khóa đã được sử dụng. Vui lòng cung cấp một tên khóa duy nhất.',
        createddt: 'Ngày tạo',
        kind: 'Loại',
        addnew: 'Thêm mới',
        search: 'Tìm kiếm',
        download: 'Tải xuống',
        id: 'ID',
        details: 'Chi tiết',
        startdatetime: 'Ngày giờ bắt đầu',
        enddatetime: 'Ngày giờ kết thúc',
        histories: 'Lịch sử',
        gmail: 'Google mail',
        clicktocopy: 'Bấm để sao chép',
        duplicate: 'Nhân bản',
        build: 'Thiết lập flow',
        run: 'Chạy',
        back: 'Trở lại',
        options: 'Tùy chọn',
        thisfieldisrequired: 'Trường này là bắt buộc.',
        url: 'Url',
        selector: 'Bộ chọn CSS',
        text: 'Văn bản',
        browser: 'Trình duyệt',
        outputkey: 'Output key',
        condition: 'Điều kiện',
        undo: 'Hoàn tác',
        redo: 'Làm lại',
        specifycalculation: 'Chỉ định phép tính',
        openbrowser: 'Mở trình duyệt',
        click: 'Nhấp chuột',
        if: 'Điều kiện If',
        endif: 'Kết thúc If',
        comment: 'Ghi chú',
        miscellaneous: 'Tổng hợp',
        control: 'Điều khiển',
        update: 'Cập nhật',
        rowsperpage: 'Mục trên mỗi trang',
        msg_youraccounthasbeenupdated: 'Tài khoản của bạn đã được cập nhật.',
        msg_fileextensionsarenotallowed: 'Phần mở rộng tệp không được phép.',
        msg_pleaseuploadthefile: 'Vui lòng tải tệp lên.',
        msg_fileistoobig: 'Tệp quá lớn (tối đa 10MB).',
        msg_youravatarhasbeenupdated: 'Hình đại diện của bạn đã được cập nhật.',
        msg_currentpasswordisinvalid: 'Mật khẩu hiện tại không hợp lệ.',
        msg_newpasswordandconfirmpassworddoesnotmatch: 'Mật khẩu mới và mật khẩu xác nhận không khớp.',
        msg_changepasswordsuccess: 'Thay đổi mật khẩu thành công.',
        addnewuser: 'Thêm mới',
        edituser: 'Cập nhật',
        language: 'Ngôn ngữ',
        english: 'English',
        vietnamese: 'Tiếng Việt',
        japanese: '日本語',
        languageofverifyemail: 'Ngôn ngữ xác minh email',
        msg_addnewusersuccess: 'Thêm người dùng mới thành công.',
        msg_editusersuccess: 'Cập nhật người dùng thành công.',
        msg_inactiveuserwassuccess: 'Đã chuyển trạng thái sang không hoạt động.',
        msg_activeuserwassuccess: 'Đã chuyển trạng thái sang hoạt động',
        msg_deleteuserwassuccess: 'Đã xoá người dùng thành công.',
        confirmactionuser: 'Bạn có muốn {action} người dùng đã chọn không?',
        uploadfile: 'Tải tệp lên',
        filepath: 'Đường dẫn tệp',
        projects: 'Dự án',
        projectname: 'Tên dự án',
        members: 'Thành viên',
        robots: 'Robots',
        createddate: 'Ngày tạo',
        createduser: 'Người tạo',
        projectnameexample: 'Dự án demo',
        descriptionexample: 'Đây là một dự án demo',
        deleteprojectconfirm: 'Bạn có chắc chắn xóa "{projectName}" không?',
        deleteprojectsubtitle: 'Vui lòng nhập [xóa] để xác nhận.',
        msg_addnewprojectsuccess: 'Thêm dự án mới thành công.',
        msg_editprojectsuccess: 'Cập nhật dự án thành công.',
        msg_deleteprojectwassuccess: 'Xóa dự án thành công.',
        msg_deleteprojecterror: 'Bạn không thể xóa dự án vì nó chứa các robots khác.',
        updaterobot: 'Cập nhật robot',
        addnewrobot: 'Thêm mới robot',
        robotname: 'Tên robot',
        icon: 'Biểu tượng',
        backgroundcolor: 'Màu nền',
        color: 'Màu biểu tượng',
        sendinganemailwhenanerroroccurs: 'Gửi email khi xảy ra lỗi',
        msg_addnewscriptsuccess: 'Thêm robot mới thành công.',
        msg_editscriptsuccess: 'Cập nhật robot thành công.',
        msg_deletescriptwassuccess: 'Xóa robot đã thành công.',
        deletescriptconfirm: 'Bạn có chắc chắn xóa "{scriptName}" không?',
        duplicaterobot: 'Nhân bản robot',
        msg_duplicatescriptsuccess: 'Nhân bản robot thành công.',
        msg_savescriptwassuccess: 'Lưu kịch bản thành công.',
        gmailconnectiondescription: 'Xem hoặc gửi email.',
        googlespreadsheetsconnectiondescription: 'Đọc hoặc viết một trang tính.',
        googledriveconnectiondescription: 'Xem, chỉnh sửa, tạo và xóa tất cả các tệp.',
        googlecalendarconnectiondescription: 'Nhận hoặc đặt sự kiện lịch.',
        awss3connectiondescription: 'Tải tệp xuống hoặc đăng tệp lên S3.',
        filemakerconnectiondescription: 'Đọc hoặc ghi tài liệu và thực thi các tập lệnh.',
        googledocsconnectiondescription: 'Đọc hoặc viết tất cả các tài liệu.',
        ftpconnectiondescription: 'Tải tệp xuống hoặc đăng tệp lên FTP.',
        bucketname: 'Bucket Name',
        accesskeyid: 'Access Key ID',
        secretaccesskey: 'Secret Access Key',
        host: 'Host',
        version: 'Version',
        username: 'User Name',
        database: 'Database',
        msg_updateconnectionsuccess: 'Cập nhật kết nối thành công',
        msg_createconnectionsuccess: 'Tạo kết nối đã thành công',
        msg_cannotupdateconnection: 'Không thể cập nhật kết nối',
        msg_cannotcreateconnection: 'Không thể tạo kết nối',
        connectionlist: 'Danh sách kết nối',
        msg_pleaseenterthedataintherequiredfield: 'Vui lòng nhập vào trường bắt buộc',
        deleteconnectionconfirm: 'Bạn có chắc chắn xóa "{name}" không?',
        msg_deleteconnectionwassuccess: 'Xóa kết nối đã thành công.',
        copiedtoclipboard: 'Đã sao chép vào khay nhớ tạm',
        copypath: 'Sao chép đường dẫn',
        path: 'Đường dẫn',
        totalsize: 'Tổng kích thước',
        msg_deletestoragesuccess: 'Xóa tệp/thư mục đã thành công.',
        deletedirectoryconfirm: 'Bạn có chắc chắn xóa tệp/thư mục đã chọn không?',
        addnewsubdirectory: 'Thêm thư mục con mới',
        uploadfilestodirectory: 'Tải tệp lên thư mục',
        directory: 'Thư mục',
        directories: 'Thư mục',
        actions: 'Tùy chọn',
        type: 'Loại',
        directoryname: 'Tên thư mục',
        msg_directoryalreadyexists: 'Thư mục đã tồn tại.',
        msg_addnewsubdirectorysuccess: 'Thêm thư mục con thành công.',
        uploadfilestodirectoryconfirm: 'Bạn có muốn tải tệp lên thư mục "{name}" không?',
        msg_uploadfilessuccess: 'Tải tệp lên thư mục đã thành công.',
        editdirectoryname: 'Chỉnh sửa tên thư mục',
        msg_updatedirectorysuccess: 'Cập nhật thư mục thành công.',
        disabled: 'Đã vô hiệu',
        ready: 'Sẳn sàng',
        disable: 'Vô hiệu',
        enable: 'Kích hoạt',
        running: 'Đang chạy',
        selectrobot: 'Chọn robot',
        edittrigger: 'Tuỳ chỉnh trình kích hoạt',
        confirmschedule: 'Xác nhận lịch trình',
        next: 'Tiếp theo',
        msg_addnewschedulesuccess: 'Thêm lịch trình mới thành công.',
        msg_updateschedulesuccess: 'Cập nhật lịch trình thành công.',
        msg_deleteschedulewassuccess: 'Xóa lịch trình thành công.',
        confirmactionschedule: 'Bạn có muốn {action} lịch trình đã chọn không?',
        msg_enableschedulrwassuccess: 'Đã bật (các) lịch trình thành công.',
        msg_disableschedulrwassuccess: 'Đã tắt (các) lịch trình thành công.',
        msg_expireduser: 'Tài khoản đã hết hạn.',
        expirationnotice: 'Bạn còn {numberOfValidDays} ngày để sử dụng RPA CLOUD.',
        expirationnotice_2: 'Để tránh bị gián đoạn, vui lòng liên hệ với admin.',
        runscriptconfirm: 'Bạn có muốn chạy "{scriptName}" không?',
        selectyourprojectname: 'Chọn dự án của bạn',
        enteryourrobotname: 'Nhập tên robot của bạn',
        screenshot: 'Ảnh chụp màn hình',
        basicauthusername: 'Tên đăng nhập (Basic Auth)',
        basicauthpassword: 'Mật khẩu (Basic Auth)',
        clearvalue: 'Xóa giá trị',
        keyboards: 'Bàn phím',
        downloadfile: 'Tải xuống tệp',
        stop: 'Dừng lại',
        steps: 'Bước',
        step: 'Bước',
        acceptdialog: 'Chấp nhận hộp thoại',
        paste: 'Dán',
        copy: 'Sao chép',
        msg_missingifstep: 'Thiếu bước "Điều kiện If"',
        msg_missingendifstep: 'Thiếu bước "Kết thúc If"',
        msg_missingendloopstep: 'Thiếu bước "Kết thúc Loop"',
        msg_missingloopstep: 'Thiếu bước "Vòng lặp Loop"',
        msg_missingendforeachstep: 'Thiếu bước "Kết thúc For-each"',
        msg_missingforeachstep: 'Thiếu bước "Vòng lặp For-each"',
        msg_invalidscriptstep: 'Các bước trong kịch bản không hợp lệ',
        concatenate: 'Ngoặc kép',
        parentheses: 'Dấu ngoặc đơn',
        equalto: 'Bằng',
        notequalto: 'Không bằng',
        greaterthan: 'Lớn hơn',
        lessthan: 'Nhỏ hơn',
        greaterthanorequalto: 'Lớn hơn hoặc bằng',
        lessthanorequalto: 'Nhỏ hơn hoặc bằng',
        carriagereturn: 'Xuống dòng',
        plus: 'Cộng (hoặc nối chuỗi)',
        minus: 'Trừ',
        multiply: 'Nhân',
        divide: 'Chia',
        and: 'Toán tử And',
        or: 'Toán tử Or',
        not: 'Toán tử Not',
        get: 'Nhận',
        msg_thespecifiedfieldcannotbefound: 'Không thể tìm thấy: {caculation}',
        msg_missing: 'Thiếu {name}',
        textismustbeinbetweendoublequotation: 'Văn bản phải nằm giữa dấu ngoặc kép (ví dụ: "abc")',
        ignoreerror: 'Bỏ qua lỗi',
        actionsfordownload: 'Hành động để tải xuống',
        selectoption: 'Chọn tùy chọn',
        coordinatex: 'Tọa độ X',
        coordinatey: 'Tọa độ Y',
        windowsize: 'kích cỡ màn hình',
        format: 'Định dạng',
        scale: 'Tỉ lệ',
        pageranges: 'Phạm vi trang',
        timeout: 'Thời gian chờ (mili giây)',
        findelementby: 'Tìm phần tử theo',
        attribute: 'Thuộc tính',
        tab: 'Tab',
        waitfornavigation: 'Chờ điều hướng',
        fullpage: 'Toàn trang',
        targetselector: 'Bộ chọn mục tiêu',
        destinationselector: 'Bộ chọn đích',
        kill: 'Kết thúc',
        msg_killschedulewassuccess: 'Đã kết thúc lịch trình thành công.',
        createddatetime: 'Ngày giờ tạo',
        view: 'Xem',
        executor: 'Người thi hành',
        msg_pleaseupgradeyourplantocreateanewrobot: 'Vui lòng nâng cấp gói của bạn để tạo một robot mới.',
        msg_pleaseupgradeyourplantocreateanewconnection: 'Vui lòng nâng cấp gói của bạn để tạo kết nối mới.',
        msg_pleaseupgradeyourplantouploadfile: 'Bộ nhớ của bạn đã đầy. Vui lòng xóa các tệp/thư mục không cần thiết khỏi bộ lưu trữ của bạn hoặc nâng cấp gói hiện tại của bạn.',
        msg_pleaseupgradeyourplantocreateanewschedule: 'Vui lòng nâng cấp gói của bạn để tạo một lịch trình mới.',
        termsofuse: 'Điều khoản sử dụng',
        date: 'Ngày',
        number: 'Số',
        logical: 'Luận lý',
        value: 'Giá trị',
        gettingstarted: 'Bắt đầu',
        usage: 'Cách sử dụng',
        connections: 'Kết nối',
        iwouldliketoupgradepackage: 'Tôi muốn nâng cấp gói cho RPA CLOUD.',
        message: 'Lời nhắn',
        pleaseenteravalidphonemessage: 'Nhập nội dung bạn cần vào đây.',
        msg_toomanyrequestsfromthisip: 'Quá nhiều yêu cầu từ IP này, vui lòng thử lại sau một giờ.',
        benefitsofusingrpacloud: 'Lợi ích của việc sử dụng RPA CLOUD',
        benefitsofusingrpaclouddescription: 'Bằng việc sử dụng RPA CLOUD, bạn có thể tự động hóa công việc để có thể tiết kiệm thời gian, tiết kiệm chi phí và thực hiện các công việc đó chính xác nhất.',
        savetime: 'Tiết kiệm thời gian',
        costefficiency: 'Hiệu quả chi phí',
        accuratetask: 'Công việc chính xác',
        howtouserpacloud: 'Sử dụng RPA CLOUD như thế nào?',
        howtouserpaclouddescription: 'Mọi thứ bạn cần chỉ là một PC có kết nối Internet.',
        createyourrobot: 'Tạo robot của bạn',
        createyourrobotdescription: 'Hãy tưởng tượng hệ thống như một trợ lý ảo sẽ học theo những thao tác của bạn. Bạn chỉ cần hướng dẫn robot từng thao tác giống như khi bạn tự mình thực hiện công việc.',
        testtherobot: 'Kiểm tra robot',
        testtherobotdescription: 'Bằng cách sử dụng chức năng "Chạy", bạn có thể kiểm tra robot đã được lập trình chính xác và thực hiện các hành động bạn mong muốn hay chưa. ',
        settheschedule: 'Đặt lịch trình',
        setthescheduledescription: 'Chỉ định thời gian mà bạn muốn robot thực hiện các công việc thay bạn, còn bạn chỉ cần ngồi thư giãn để robot làm việc cho bạn.',
        uniquefeature: 'Khám phá những tính năng độc đáo của RPA CLOUD',
        uniquefeaturedescription: 'RPA CLOUD cung cấp nhiều chức năng đa dạng có thể được thực hiện trên nhiều nền tảng bao gồm Google Chrome, Excel, Gmail, Google Spreadsheet, Google Drive, Google Calendar, Google Docs, AWS S3 và FileMaker.',
        code: 'Code',
        incrediblyeasytogetgoing: 'Cực kỳ dễ dàng để bắt đầu',
        times: 'Số lần',
        iterable: 'Iterable',
        scheduled: 'Đã lên lịch trình',
        msg_cannotdeletescriptbecause: 'Bạn không thể xóa robot vì robot này đã được lên lịch.',
        freeupto30daysnocreditcardrequired: 'Miễn phí lên đến 30 ngày. Không cần thẻ tín dụng.',
        filename: 'Tên tệp',
        fullpath: 'Đường dẫn đầy đủ',
        encoding: 'Mã hóa',
        array: 'Mảng',
        object: 'Đối tượng',
        arraydata: 'Dữ liệu mảng',
        arrayindex: 'Chỉ số của mảng',
        objectdata: 'Dữ liệu đối tượng',
        objectkey: 'Khóa của đối tượng',
        createarray: 'Tạo mảng',
        element: 'Phần tử',
        deleteelement: 'Xoá phần tử',
        addnewelement: 'Thêm phần tử',
        key: 'Khoá',
        deleteobject: 'Xoá đối tượng',
        addnewobject: 'Thêm đối tượng',
        createobject: 'Tạo đối tượng',
        splitwith: 'Phân cắt bằng',
        find: 'Tìm',
        replacewith: 'Thay thế bằng',
        regexp: 'Biểu thức chính quy',
        sheetname: 'Tên trang tính',
        newsheetname: 'Tên trang tính mới',
        worksheet: 'Bảng tính',
        celllabel: 'Nhãn ô',
        range: 'Phạm vi',
        headers: 'Headers',
        contents: 'Nội dung',
        json: 'JSON',
        excel: 'Excel',
        spreadsheet: 'Google Spreadsheet',
        drive: 'Google Drive',
        calendar: 'Google Calendar',
        installation: 'Cài đặt',
        usageperiod: 'Thời hạn sử dụng',
        copylink: 'Sao chép đường dẫn',
        chromeextension: 'Tiện ích mở rộng Chrome',
        setvariable: 'Đặt biến',
        runjavascript: 'Chạy javascript',
        subtitle__gettingstarted_installation: 'Hãy cài đặt các công cụ cần thiết để sử dụng RPA CLOUD.',
        getcssselector: 'Lấy bộ chọn CSS',
        subtitle__gettingstarted_usage: 'Tìm hiểu kiến thức cơ bản về cách làm việc với RPA CLOUD.',
        actiontask: 'Hành động',
        makeyourfirstrobot: 'Tạo robot đầu tiên',
        runyourrobot: 'Chạy robot của bạn',
        schedulerobotrun: 'Đặt lịch chạy robot',
        msg_companyName_invalid: 'Tên không hợp lệ.',
        msg_telNumber_invalid: 'Số điện thoại công ty không hợp lệ.',
        msg_firstName_invalid: 'Tên không hợp lệ.',
        msg_lastName_invalid: 'Họ không hợp lệ.',
        msg_password_invalid: 'Mật khẩu không hợp lệ.',
        msg_plan_invalid: 'Gói không hợp lệ.',
        msg_locale_invalid: 'Ngôn ngữ không hợp lệ.',
        msg_paymentfailed: 'Thanh toán thất bại. Xin vui lòng thử lại.',
        msg_paymentsuccess: 'Thanh toán thành công.',
        chromiumtitle: 'Thao tác với trình duyệt Chrome',
        chromiumdescription: 'Hầu hết những việc bạn có thể thực hiện thủ công trong trình duyệt đều có thể được thực hiện tại đây: tạo ảnh chụp màn hình và tệp PDF của các trang, tự động gửi biểu mẫu, kiểm tra giao diện người dùng, nhập liệu bằng bàn phím, tải tệp xuống, đăng tải tệp lên v.v.',
        exceltitle: 'Thao tác với Excel',
        exceldescription: 'Những việc như đọc/thêm/xoá/sửa dữ liệu trong Excel đều có thể thực hiện tại đây.Ngoài ra bạn còn có thể đọc/ghi tệp CSV, chuyển đổi Excel sang CSV v.v.',
        gmailtitle: 'Thao tác với Gmail',
        gmaildescription: 'Tính năng này cho phép bạn gửi email từ tài khoản Gmail của bạn thông qua API Gmail. Ngoài ra bạn có thể tìm kiếm thư trong hộp thư, lấy nội dung, tải về tệp đính kèm v.v.',
        googlespreadsheettitle: 'Thao tác với Google Spreadsheet',
        googlespreadsheetdescription: 'Tính năng này cho phép bạn đọc/thêm/xoá/sửa dữ liệu trong trang tính bằng API Google Spreadsheet. Ngoài ra bạn có thể thêm mới, sao chép, tải về tệp trang tính v.v.',
        googledrivetitle: 'Thao tác với Google Drive',
        googledrivedescription: 'Tính năng này cho phép bạn quản lý tệp trong Drive bao gồm tải lên, tải xuống thông qua API Google Drive.',
        googlecalendartitle: 'Thao tác với Google Calendar',
        googlecalendardescription: 'Tính năng này cho phép bạn quản lý lịch và sự kiện của mình thông qua API Google Calendar.',
        googledocstitle: 'Thao tác với Google Docs',
        googledocsdescription: 'Tính năng này cho phép bạn đọc/viết tất cả các tài liệu thông qua API Google Calendar.',
        awss3title: 'Thao tác với AWS S3',
        awss3description: 'Bằng cách liên kết với AWS S3, bạn có thể tải tệp và lưu tệp vào nhóm S3. Quyền vận hành nhóm S3 là quyền IAM được chỉ định trong bảng điều khiển AWS.',
        filemakertitle: 'Thao tác với FileMaker',
        filemakerdescription: 'Dựa vào API mà FileMaker cung cấp bạn có thể đọc/thêm/xoá/sửa bảng ghi trong FileMaker. Ngoài ra bạn có thể thực thi kịch bản trong FileMaker v.v.',
        texttitle: 'Thao tác với file Text',
        textdescription: 'Bạn có thể chuyển tệp .txt/PDF thành văn bản.Ngoài ra bạn có thể cắt/thay thế/tìm kiếm/chuyển đổi sang chữ hoa/chuyển đổi sang chữ thường v.v.',
        docs: 'Google Docs',
        filemaker: 'FileMaker',
        awss3: 'AWS S3',
        clientid: 'client ID',
        to: 'Đến',
        subject: 'Tiêu đề',
        body: 'Tin nhắn',
        attachments: 'Tệp đính kèm',
        from: 'Từ',
        cc: 'CC',
        bcc: 'BCC',
        query: 'Truy vấn',
        limit: 'Giới hạn',
        markasread: 'Đánh dấu là đã đọc',
        gmailmessages: 'Tin nhắn Gmail',
        calendarid: 'Calendar ID',
        summary: 'Tóm tắt',
        descriptions: 'Mô tả',
        eventid: 'Event ID',
        attendees: 'Người tham dự',
        fileid: 'File ID',
        spreadsheetid: 'Spreadsheet ID',
        title: 'Tiêu đề',
        spreadsheetdestination: 'Spreadsheet (đích)',
        sheetnamedestination: 'Tên trang tính (đích)',
        extension: 'Phần mở rộng',
        method: 'Method',
        params: 'Params',
        httpheaders: 'Headers',
        layout: 'Layout',
        parameters: 'Parameters',
        fielddata: 'Field data',
        recordid: 'Record ID',
        scriptname: 'Script name',
        containerfieldname: 'Container fieldname',
        globalfields: 'Global fields',
        webservice: 'Dịch vụ web',
        msg_cannotrunschedulerightnow: 'Lịch trình đang chạy, không thể chạy lịch trình ngay bây giờ.',
        msg_scheduleisdisabled: 'Lịch trình đang bị vô hiệu.',
        createyouritemandstartexperimentingnow: 'Tạo {item} của bạn và bắt đầu trải nghiệm ngay.',
        script: 'Kịch bản',
        passwords: 'Mật khẩu',
        documentid: 'Document ID',
        document: 'Document',
        index: 'Chỉ số',
        function: 'Hàm số',
        functions: 'Hàm số',
        subtitle__actiontask_miscellaneous: 'Một số hành động cơ bản để bắt đầu sử dụng RPA CLOUD.',
        parameters__title: 'Tham số (* là tham số bắt buộc)',
        parameters__name: 'Tên',
        parameters__type: 'Kiểu',
        parameters__description: 'Mô tả',
        parameters__default: 'Giá trị mặc định',
        returndatatype__title: 'Kiểu dữ liệu trả về',
        example__title: 'Ví dụ',
        datatype__text: 'Văn bản',
        datatype__number: 'Số',
        datatype__array: 'Mảng (JSON)',
        datatype__object: 'Đối tượng (JSON)',
        datatype__boolean: 'Giá trị thực',
        datatype__any: 'Bất kỳ',
        dependingonstoredvalue: '(tùy thuộc vào giá trị được lưu trữ)',
        subtitle__actiontask_browser: 'Danh sách các hành động trình duyệt. Các hành động của trình duyệt tương ứng với các hoạt động như khởi động trình duyệt và nhấp vào bên trong trình duyệt. Đặt bộ chọn CSS để thao tác các phần tử trong trình duyệt v.v.',
        supplement__title: 'Bổ sung',
        textonly: 'Chỉ có văn bản',
        typetext: 'Nhập văn bản',
        typepassword: 'Nhập mật khẩu',
        keyboardpress: 'Nhấn bàn phím',
        gettext: 'Lấy văn bản',
        clickpoint: 'Nhấp vào điểm X,Y',
        takescreenshot: 'Chụp màn hình',
        pagepdf: 'Lưu màn hình thành PDF',
        hover: 'Di chuột',
        scrapepage: 'Cào dữ liệu trên trang',
        findelement: 'Tìm kiếm phần tử',
        geturl: 'Lấy địa chỉ URL',
        getattribute: 'Lấy thuộc tính',
        waitforselector: 'Chờ đợi bộ chọn xuất hiện',
        draganddrop: 'Kéo và thả',
        injectjavascript: 'Chèn JavaScript',
        gotourl: 'Chuyển đến URL',
        goback: 'Quay lại',
        switchtab: 'Chuyển tab',
        showtabs: 'Hiển thị các tab',
        closebrowser: 'Đóng trình duyệt',
        subtitle__actiontask_storages: 'Danh sách các hành động để thao tác với các tệp hoặc thư mục trong kho luu trữ.',
        listfiles: 'Liệt kê các tệp',
        renamefile: 'Đổi tên tệp',
        movefiles: 'Di chuyển các tệp',
        deletefiles: 'Xoá các tệp',
        copyfiles: 'Sao chép các tệp',
        compressfiles: 'Nén các tệp',
        decompressfiles: 'Giải nén các tệp',
        subtitle__actiontask_json: 'Danh sách các hành động xử lý dữ liệu như mảng và đối tượng.',
        getelementfromarray: 'Lấy phần tử từ mảng',
        getvaluefromobject: 'Lấy giá trị từ đối tượng',
        subtitle__actiontask_text: 'Danh sách các hành động thao tác chuỗi.',
        createtext: 'Tạo văn bản',
        splittext: 'Tách văn bản',
        replacetext: 'Thay thế văn bản',
        matchtext: 'Tìm trùng khớp văn bản',
        readtext: 'Đọc văn bản',
        convertpdftotext: 'Chuyển đổi PDF thành văn bản',
        appendvaluetotextfile: 'Nối giá trị vào tệp văn bản',
        subtitle__actiontask_excel: 'Danh sách các hành động để vận hành các tệp Excel.',
        createnewfile: 'Tạo tệp mới',
        getsheetnames: 'Lấy tên các trang tính',
        changesheetname: 'Thay đổi tên trang tính',
        selectsheet: 'Chọn trang tính',
        readcell: 'Đọc giá trị trong ô',
        writecell: 'Viết giá trị trong ô',
        readrange: 'Đọc giá trị trong phạm vi',
        writerange: 'Viết giá trị trong phạm vi',
        deleterange: 'Xoá giá trị trong phạm vi',
        convertexceltocsv: 'Chuyển đổi Excel sang CSV',
        writecsv: 'Viết tệp CSV',
        readcsv: 'Đọc tệp CSV',
        appendvaluetocsvfile: "Thêm giá trị vào tệp CSV",
        companyname: 'Tên công ty',
        telnumber: 'Số điện thoại',
        subtitle__actiontask_gmail: 'Danh sách các hành động gửi và nhận email.',
        sendmail: 'Gửi Gmail',
        getgmail: 'Lấy thông tin Gmail',
        gmaildownloadattachments: 'Tải xuống tệp đính kèm trong Gmail',
        subtitle__actiontask_calendar: 'Danh sách các hành động liên quan đến tích hợp Lịch Google.',
        getcalendarevents: 'Lấy sự kiện lịch',
        createcalendarevent: 'Tạo sự kiện trên lịch',
        removecalendarevent: 'Xoá sự kiện trên lịch',
        subtitle__actiontask_drive: 'Danh sách các hành động vận hành Google Drive.',
        createdrivefile: 'Tạo tệp Drive',
        getdrivefile: 'Lấy tệp Drive',
        subtitle__actiontask_docs: 'Danh sách các hành động để vận hành Google Documents.',
        createdocs: 'Tạo tài liệu Docs',
        getdocs: 'Lấy tài liệu Docs',
        docsinsertparagraph: 'Chèn đoạn văn vào tài liệu Docs',
        subtitle__actiontask_spreadsheets: 'Danh sách các hành động hoạt động với Google Spreadsheets.',
        createspreadsheet: 'Tạo tài liệu Spreadsheet',
        getspreadsheet: 'Lấy tài liệu Spreadsheet',
        getvalues: 'Lấy các giá trị',
        updatevalues: 'Cập nhật các giá trị',
        appendvalues: 'Thêm các giá trị vào cuối',
        clearvalues: 'Xoá các giá trị',
        duplicatesheet: 'Sao chép trang tính',
        downloadsheets: 'Tải xuống các trang tính',
        appendsheet: 'Thêm trang tính mới',
        subtitle__actiontask_awss3: 'Danh sách các hành động vận hành AWS S3.',
        uploads3file: 'Tải tệp lên S3',
        downloads3file: 'Tải xuống tệp S3',
        subtitle__actiontask_webservice: 'Danh sách các hành động tải xuống tệp trên web hoặc gửi yêu cầu HTTP.',
        httprequest: 'Yêu cầu HTTP',
        getfilefromurl: 'Lấy tệp từ URL',
        subtitle__actiontask_filemaker: 'Danh sách các hành động vận hành FileMaker.',
        getrecords: 'Lấy các bản ghi',
        createrecord: 'Tạo bản ghi mới',
        getsinglerecordbyid: 'Lấy một bản ghi theo Id',
        editrecord: 'Chỉnh sửa bản ghi',
        deleterecord: 'Xoá bản ghi',
        duplicaterecord: 'Nhân bản bản ghi',
        findrecords: 'Tìm các bản ghi',
        executescript: 'Thực thi tập lệnh',
        uploadtocontainerfield: 'Tải lên trường Container',
        setglobalfields: 'Thiết lặp các trường Global',
        subtitle__actiontask_control: 'Danh sách các hành động điều khiển.',
        loop: 'Vòng lặp Loop',
        forearch: 'Vòng lặp ForEarch',
        breakif: 'Điều kiện thoát khỏi Loop/ForEarch',
        wait: 'Chờ đợi',
        runrobot: 'Chạy Robot',
        utcoffset: 'UTC offset',
        subtitle__connections_gmail: 'Bằng cách liên kết với API Gmail, bạn có thể sử dụng hành động để gửi email từ tài khoản được liên kết.',
        createaconnectionwithgmail: 'Tạo kết nối với Gmail',
        subtitle__connections_drive: 'Bằng cách liên kết với API Google Drive, bạn có thể thực hiện các thao tác như truy xuất, tải lên và xóa tệp khỏi Google Drive trong hành động.',
        createaconnectionwithdrive: 'Tạo kết nối với Google Drive',
        subtitle__connections_calendar: 'Bằng cách liên kết với API Lịch Google, bạn có thể sử dụng các tác vụ để lấy thông tin từ Lịch Google.',
        createaconnectionwithcalendar: 'Tạo kết nối với Lịch Google',
        subtitle__connections_docs: 'Bằng cách liên kết với API Google Tài liệu, bạn có thể tạo, truy xuất và chỉnh sửa Google Tài liệu.',
        createaconnectionwithdocs: 'Tạo kết nối với Google Tài liệu',
        subtitle__connections_spreadsheet: 'Bằng cách liên kết với API Bảng tính Google, bạn có thể sử dụng các hành động cho phép bạn tạo bảng tính mới và thao tác với các ô.',
        createaconnectionwithspreadsheet: 'Tạo Kết nối Với Bảng tính Google',
        subtitle__connections_awss3: 'Bằng cách liên kết với AWS S3, bạn có thể truy xuất tệp từ bộ chứa S3 và lưu tệp vào bộ chứa trong các hành động. Quyền vận hành bộ chứa S3 sẽ là quyền IAM của anh ấy được chỉ định trong bảng điều khiển AWS. Liên kết này là liên kết với một thùng cố định.',
        createaconnectionwithawss3: 'Tạo kết nối với AWS S3',
        subtitle__connections_ftp: 'Bằng cách liên kết với FTP, bạn có thể tải xuống tệp hoặc tải tệp lên FTP và hơn thế nữa.',
        createaconnectionwithftp: 'Tạo kết nối với FTP',
        subtitle__connections_filemaker: 'Bằng cách liên kết với API FileMaker, bạn có thể sử dụng các hành động để tạo, chỉnh sửa, xóa bản ghi, thực thi tập lệnh, v.v.',
        createaconnectionwithfilemaker: 'Tạo kết nối với FileMaker',
        subtitle__functions_get: 'Danh sách các hàm truy xuất thông tin ngày giờ hiện tại, thông tin các tệp trong kho lưu trữ, hoặc các tham số được truyền vào.',
        fxgetcurrentdate: 'GetCurrentDate(UTC offset , Định dạng)',
        fxgetcurrenttime: 'GetCurrentTime(UTC offset , Định dạng)',
        fxgetcurrenttimestamp: 'GetCurrentTimestamp(UTC offset , Định dạng)',
        fxgetfilesizeiniytes: 'GetFilesizeInBytes(Đường dẫn tệp)',
        fxgetnumberoffiles: 'GetNumberOfFiles(Thư mục)',
        fxgetscriptparameter: 'GetScriptParameter()',
        subtitle__functions_date: 'Danh sách các hàm ngày tính toán ngày và thao tác thông tin ngày.',
        fxday: 'Day(Ngày)',
        fxdayname: 'DayName(Ngày)',
        fxdayofweek: 'DayOfWeek(Ngày)',
        fxdayofyear: 'DayOfYear(Ngày)',
        fxmonth: 'Month(Ngày)',
        fxmonthname: 'MonthName(Ngày)',
        fxweekofyear: 'WeekOfYear(Ngày)',
        fxyear: 'Year(Ngày)',
        fxsetdate: 'SetDate(Năm, Tháng, Ngày, Định dạng)',
        subtitle__functions_text: 'Danh sách các hàm văn bản có thể được sử dụng để phân tích, sắp xếp lại, trích xuất và xây dựng các chuỗi văn bản.',
        fxtostring: 'ToString(Văn bản)',
        fxleft: 'Left(Văn bản , Số ký tự)',
        fxmiddle: 'Middle(Văn bản , Vị trí bắt đầu , Số ký tự)',
        fxright: 'Right(Văn bản , Số ký tự)',
        fxstringlength: 'StringLength(Văn bản)',
        fxtolower: 'ToLower(Văn bản)',
        fxtoupper: 'ToUpper(Văn bản)',
        fxpatterncount: 'PatternCount(Văn bản , Chuỗi tìm kiếm)',
        fxsubstitute: 'Substitute(Văn bản , [[ Chuỗi tìm kiếm , Chuỗi thay thế ]])',
        fxtotrim: 'ToTrim(Văn bản)',
        fxtotrimall: 'ToTrimAll(Văn bản)',
        fxindexofstring: 'IndexOfString(Văn bản , Chuỗi tìm kiếm)',
        fxsplit: 'Split(Văn bản , Phân cắt bằng)',
        fxmatch: 'Match(Văn bản , Biểu thức chính quy)',
        subtitle__functions_number: 'Danh sách các hàm số được sử dụng để thao tác dữ liệu số.',
        fxtonumber: 'ToNumber(Văn bản)',
        fxrandom: 'Random()',
        fxtoceiling: 'ToCeiling(Số)',
        fxtofloor: 'ToFloor(Số)',
        subtitle__functions_logical: 'Danh sách các hàm logic kiểm tra một điều kiện để đánh giá nó là đúng hay sai.',
        fxif: 'If(Điều kiện , Kết quả 1 , Kết quả 2)',
        fxcase: 'Case([[ Điều kiện , kết quả ]] , Kết quả mặt định)',
        fxisempty: 'IsEmpty(Văn bản)',
        year: 'Năm',
        month: 'Tháng',
        day: 'Ngày',
        numberofcharacters: 'Số ký tự',
        searchstring: 'Chuỗi tìm kiếm',
        replacestring: 'Chuỗi thay thế',
        results: 'kết quả',
        defaultresult: 'Kết quả mặt định',
        companycategory: 'Danh mục công ty',
        new: 'Mới',
        existing: 'Hiện có',
        excludingholidays: 'Không chạy vào các ngày lễ',
        excludingweekends: 'Không chạy vào thứ bảy và chủ nhật',
        else: 'Else (nếu không thoả If)',
        endloop: 'Kết thúc Loop',
        foreach: 'Vòng lặp For-each',
        endforeach: 'Kết thúc For-each',
        viewfile: 'Xem tệp',
        sendgmail: 'Gửi gmail',
        allowedfilesextensionsareasfollows: 'Phần mở rộng được phép',
        rpacloudssubtitle: 'THÊM THỜI GIAN, THÊM CƠ HỘI',
        highlightfeatures: [
            {
                title: 'Cá nhân hoá'
                , content: 'Phục vụ nhu cầu cá nhân với nhiều gói có sẵn, bạn có thể tìm thấy gói phù hợp với yêu cầu của mình.'
            },
            {
                title: 'Linh hoạt'
                , content: 'Truy cập từ mọi nơi và mọi lúc, giúp bạn dễ dàng quản lý các quy trình tự động hóa từ xa.'
            },
            {
                title: 'Đa chức năng'
                , content: 'Tự động hóa công việc một cách dễ dàng, ngay cả khi bạn không có kiến thức nào về lập trình nhờ vào hàng loạt tính năng thông minh.'
            }
        ],
        frequentlyaskedquestion: 'Các câu hỏi thường gặp',
        frequentlyaskedquestions: [
            {
                question: 'Những công việc nào có thể được tự động hóa bằng RPA CLOUD?'
                , answer: 'Các công việc được thực hiện trên các nền tảng như Excel, Gmail, Google Spreadsheet và FileMaker, ví dụ như trích xuất dữ liệu từ web, quản lý tệp, tự động gửi email, v.v. Nếu bạn không chắc liệu công việc cụ thể của mình có thể được tự động hóa hay không, vui lòng liên hệ với chúng tôi để biết thêm thông tin và được hỗ trợ.'
            },
            {
                question: 'Những ngôn ngữ hoặc kỹ năng lập trình nào cần thiết để có thể sử dụng RPA CLOUD?'
                , answer: 'Bạn không cần bất kỳ kiến thức nào về lập trình để sử dụng. Chỉ cần làm theo tài liệu của chúng tôi và bạn sẽ có thể phát triển robot của riêng mình.'
            },
            {
                question: 'Những kênh hỗ trợ cho khách hàng? '
                , answer: 'Chúng tôi cung cấp hỗ trợ qua email và cuộc gọi video để hỗ trợ bạn với bất kỳ câu hỏi hoặc vấn đề nào bạn có thể gặp phải.'
            }
        ],
        footerslogan: "Xây dựng trợ lý ảo của riêng bạn",
        footerscription: "Hãy dành thêm thời gian cho bản thân bằng sự hỗ trợ của robot!",
        getstarted: 'Bắt đầu ngay',
        introduceblog: "Chúng tôi chia sẻ các bài viết cập nhật mới nhất về RPA CLOUD, cũng như các hướng dẫn minh họa cách tạo bot để tự động hóa các công việc của bạn.",
        resources: "Links",
        position: 'Vị trí',
        notice: "Thông báo",
        gobackconfirm: "Bạn có muốn lưu tập lệnh trước khi quay lại không?",
        ftp: 'FTP',
        secure: 'Bảo mật',
        subtitle__actiontask_ftp: 'Danh sách các hành động thao tác với FTP server.',
        uploadfiletoftp: 'Tải tệp lên FTP',
        downloadfilefromftp: 'Tải xuống tệp FTP',
        destinationdirectory: 'Thư mục đích',
        remarks: 'Chú thích',
        delimiter: 'Dấu phân cách',
        changedelimitercsvfile: 'Thay Đổi Dấu Phân Cách Tệp CSV',
        returndatatype__noreturndata: 'Không trả về kết quả',
        extractdatafromtable: "Trích xuất dữ liệu từ bảng",
        company: "Công ty",
        users: 'Số người dùng',
        closetab: "Đóng tab",
        opennewtab: "Mở tab mới",
        clip: "Cắt ảnh",
        addnewcompany: "Thêm công ty mới",
        editcompany: "Cập nhật công ty",
        msg_addnewcompanysuccess: 'Thêm công ty mới thành công.',
        msg_updatecompanysuccess: 'Cập nhật công ty thành công.',
        msg_inactivecompanywassuccess: 'Đã chuyển trạng thái sang không hoạt động.',
        msg_activecompanywassuccess: 'Đã chuyển trạng thái sang hoạt động',
        msg_deletecompanywassuccess: 'Đã xoá công ty thành công.',
        confirmactioncompany: 'Bạn có muốn {action} công ty đã chọn không?',
        company_profile: 'Hồ sơ công ty',
        handling_of_personal_information: 'Xử lý thông tin cá nhân',
        show_histories: 'Hiển thị/Ẩn lịch sử'
    }
}

export default vi;